import React, {
    useEffect, useState, useMemo, useCallback, useContext 
} from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import {
    Icon, Loader, InfoLabel, DateField,ModalNextProvider
} from '@jutro/components';
import { BreakpointTrackerContext } from '@jutro/layout';
import { AccountBillingDetailsService } from 'gw-capability-billing';
import { UsersProfileDetailsService } from 'gw-capability-profileinfo';
import { PolicyService } from 'gw-capability-policy';
import { ClaimService } from 'gw-capability-claim';
import { AMPSubmissionDraftService } from 'gw-capability-quoteandbind';
import { DocumentService } from 'gw-capability-policydocument';
import { DateRangeComponent, Link, Currency as CurrencyField } from 'gw-components-platform-react';
import { getNormalizedLOBName, isCapabilityEnabled } from 'gw-portals-config-js';
import { useAuthentication } from 'gw-digital-auth-react';
import { /*LobIconUtil,*/ LocalDateUtil } from 'gw-portals-util-js';
import { getFontIcon } from '../../customer/module/nexus-portals-util-js/lobIconUtil';
import { generateURL } from 'gw-portals-url-js';
import { IntlContext, TranslatorContext } from '@jutro/locale';
import { ButtonLink } from '@jutro/router';
import PageBannerComponent
    from '../../components/PageBannerComponent/PageBannerComponent';
import BillingTable from '../../customer/capabilities-react/nexus-capability-billing-react/BillingTable/BilllingTable';
import {getImageSrc} from '../../customer/module/nexus-portals-util-js/lobIconUtil';
import { PhoneUtil } from 'gw-portals-viewmodel-js';

// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import styles from './LandingPage.module.scss';
import metadata from './LandingPage.metadata.json5';
import messages from './LandingPage.messages';
import PaperlessDistibutionComponent from '../PaperlessDistribution/PaperlessDistibutionComponent';
import {getBrokerUtilLogo} from './../../customer/utils/brokerLogoUtil';
import { ServiceManager } from '@jutro/services';
import { ViewModelServiceContext } from 'gw-portals-viewmodel-react';
import {getAgentPhotoUtil} from './../../customer/utils/agentPhotoUtil';


const getCellType = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const lineOfBusiness = activePeriod.lines.length > 1
        ? activePeriod.lines.map((line) => line) : _.first(activePeriod.lines);
  // const icon = activePeriod.lines.length > 1 ? 'mi-unarchive' : LobIconUtil.getMaterialIcon(lineOfBusiness);
   const icon = activePeriod.lines.length > 1 ? 'mi-unarchive' : getFontIcon(lineOfBusiness);
    return <Icon icon={icon} title={lineOfBusiness} key={lineOfBusiness} />;
};

const isPolicyActive = (periods) => {
    const currentRenewed = periods.length > 1;
    const activePeriod = _.first(periods);
    return new Date(activePeriod.effective).getTime() < new Date().getTime() && !currentRenewed;
};

const shouldRenewalNotificationShow = (accountPolicyData) => {
    return accountPolicyData.some((policy) => policy.periods.length > 1);
};

const getCellStatus = (rowData) => {
    if (isPolicyActive(rowData.periods)) {
        return <InfoLabel type="success" size="medium" message={messages.statusActive} />;
    }

    return <InfoLabel type="info" size="medium" message={messages.statusRenewed} />;
};

const getCellPolicy = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    return (
        <Link
            className={styles.link}
            to={{
                pathname: `/account-policy-details/${activePeriod.policyId}`,
                productCode: activePeriod.lines[0],
                idCard: periodWithIDCard ? {
                    idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                    idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                } : null
            }}
        >
            {activePeriod.policyId}
        </Link>
    );
};

const getPolicyNumber = (rowData) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <span className={styles.link}>
            {activePeriod.policyId}
        </span>
    );
};

const getViewPolicyBtn = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    const periodWithIDCard = rowData.periods.find((policy) => policy.idCardPublicID);
    const title = "Button to view policy details for policy number" + activePeriod.policyId
    return (
        <>
            <ButtonLink
                aria-label = {title} 
                id={`viewPolicy_${rowIndex}`}
                //className={styles.eyButtonCard}
                to={{
                    pathname: `/account-policy-details/${activePeriod.policyId}`,
                    productCode: activePeriod.lines[0],
                    idCard: periodWithIDCard ? {
                        idCardSessionID: _.get(periodWithIDCard, 'idCardSessionID'),
                        idCardPublicID: _.get(periodWithIDCard, 'idCardPublicID')
                    } : null
                }}
            >
                Details
            </ButtonLink>
            <br />
        </>
    );
};

const getCellEffective = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateRangeComponent
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod}
            fromDate="effective"
            toDate="expiration"
            hideLabel
        />
    );
};

const getPolicyEffectiveDate = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateField
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod.effective}
            format="short"
            dataType={_.isString(activePeriod.effective) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getPolicyExpiryDate = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <DateField
            id={`effectiveDate_${rowIndex}`}
            value={activePeriod.expiration}
            format="short"
            dataType={_.isString(activePeriod.expiration) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellClaim = (rowData) => {
    const activePeriod = _.first(rowData.periods);

    const redirectPath = {
        pathname: '/fnol-select-policy',
        state: {
            policyNumber: activePeriod.policyId,
            redirectPath: '/home',
            claimData: { lossDate: new Date() }
        }
    };
    return (
        <Link to={redirectPath} className={styles.link}>
            {messages.fileClaim}
        </Link>
    );
};

const getCellPremium = (rowData, rowIndex) => {
    const activePeriod = _.first(rowData.periods);
    return (
        <CurrencyField
            id={`premium_${rowIndex}`}
            value={activePeriod.premium}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellPolicyNumber = (rowData) => {
    return (
        <span>
            {rowData.displayName}
        </span>
    );
};

const getCellBillingPlan = (rowData) => {
    return (
        <span>
            {rowData.paymentPlan}
        </span>
    );
};

const getCellLastPaymentDate = (rowData, rowIndex) => {
    const invoices = rowData.invoiceSummary;
    //let latestDate = new Date(Math.max(...invoices.map((e) => new Date(e.lastPaymentDate))));
    let latestDate = new Date(rowData.lastPaymentDate)
    if (rowData.lastPaymentDate === undefined) {
        return (
            <span>
                No Payments Received
            </span>
        );
    }
    return (
        <DateField
            id={`latestDate_${rowIndex}`}
            value={latestDate}
            format="short"
            dataType={_.isString(latestDate) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellLastPayment = (rowData, rowIndex) => {
    return (
        <CurrencyField
            id={`paidAmount_${rowIndex}`}
            value={rowData.lastPaymentRecieved}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellBalanceDue = (rowData, rowIndex) => {
    return (
        <CurrencyField
            id={`dueAmount_${rowIndex}`}
            value={rowData.balance}
            dataType="object"
            readOnly
            hideLabel
        />
    );
};

const getCellBillingDetail = (rowData, rowIndex) => {
    const title = "Button to view billing details for policy number" + rowData.displayName
    return (
        <ButtonLink
        aria-label= {title}
            id={`viewBilling_${rowIndex}`}
            className={styles.link}
            to={{
                pathname: '/billing-summary/' + rowData.internalId
            }}
        >
            Details
        </ButtonLink>
    );
};

const getCellClaimPolicyNumber = (rowData) => {
    return (
        <span>
            {rowData.policyNumber}
        </span>
    );
};

const getCellDateOfLoss = (rowData, rowIndex) => {
    return (
        <DateField
            id={`dateOfLoss_${rowIndex}`}
            value={rowData.dateOfLoss}
            format="short"
            dataType={_.isString(rowData.dateOfLoss) ? 'string' : 'object'}
            readOnly
            hideLabel
            layout="full-width"
            showOptional={false}
        />
    );
};

const getCellClaimNumber = (rowData) => {
    return (
        <span>
            {rowData.claimNumber}
        </span>
    );
};

const getCellClaimDetail = (rowData, rowIndex) => {
    const title = "Button to view claim details for claim number" + rowData.claimNumber
    if (rowData.status === 'Draft') {
        const redirectPath = {
            pathname: '/fnol-select-policy',
            state: {
                claimNumber: rowData.claimNumber,
                redirectPath: '/claims',
                claimStatus: rowData.status
            }
        };
        return (
            <ButtonLink
                aria-label={title}
                id={`viewClaim_${rowIndex}`}
                className={styles.link}
                to={redirectPath}
            >
                Details
            </ButtonLink>
        );
    } else {
        const redirectPath = {
            pathname: `/claims/${rowData.claimNumber}`,
            state: {
                claimNumber: rowData.claimNumber,
                redirectPath: '/claims',
                claimStatus: rowData.status
            }
        };
        return (
            <ButtonLink
                aria-label={title}
                id={`viewClaim_${rowIndex}`}
                className={styles.link}
                to={redirectPath}
            >
                Details
            </ButtonLink>
        );
    }
};


function LandingPage(props) {
    const translator = useContext(TranslatorContext);
    const [accountBillingData, setAccountBillingData] = useState([]);
    let [accountPolicyData, setAccountPolicyData] = useState([]);
    const { authHeader } = useAuthentication();
    const [accountData, setAccountData] = useState([]);
    const [billingDetailsData, setBillingDetailsData] = useState([]);
    const [isLoading, setLoadingState] = useState(false);
    const { capabilitiesConfig } = appConfig;
    const [claimDataTable, setClaimDataTable] = useState([]);
    const [hasBillingError, setHasBillingError] = useState(false);
    const intl = useContext(IntlContext);
    const localeService = ServiceManager.getService('locale-service');
    const viewModelService = useContext(ViewModelServiceContext);
    // let [policiesLobMap, setPoliciesLobMap] = useState({});
    //  const policiesLobMap = new Map();
     const auth = useAuthentication();

    const processClaimsData = useCallback(
        (claimsData) => {
            if (!_.isEmpty(claimsData)) {
                let claimsArrayResult = claimsData;
                claimsArrayResult = claimsArrayResult.map((claimInfo) => {
                    const claims = {
                        policyLOBCode: claimInfo.lineOfBusinessCode,
                        claimNumber: claimInfo.claimNumber,
                        dateOfLoss: intl.formatDate(new Date(claimInfo.lossDate), { year: 'numeric', month: 'short', day: 'numeric' }),
                        //status: claimInfo.claimState,
                        status: translator({ id: `typekey.ClaimState.${claimInfo.claimState}`}),
                        policyNumber: claimInfo.policyNumber
                    };
                    return claims;
                });
                return claimsArrayResult;
            }
            return [];
        },
        [intl, translator]
    );

    const getClaims = useCallback(
        (query) => {
            const claimsPromise = ClaimService.getClaimSummaries(query, {}, authHeader);
            return claimsPromise
                .then((responseData) => {
                    const data = processClaimsData(responseData.items);
                    setClaimDataTable(data);
                })
                .finally(() => {
                    setLoadingState(false);
                });
        },
        [authHeader, processClaimsData]
    );

    const getCellProduct = (rowData) => {
        const lobCode = rowData.policyLOBCode;
        const icon = getFontIcon(lobCode);
        return <span className="iconFocus" tabindex="0"><Icon icon={icon} title={translator({ id: `typekey.LOBCode.${lobCode}`})} key={lobCode} /></span>;
    };

    const query = {
        claimStates: ['open', 'draft']
    };

    // const setPoliciesLobMap1 = () => {
    //     const policiesLobMap1 = new Map();
    //     accountPolicyData.forEach((accountPolicy) => {
    //         const periods = _.first(accountPolicy.periods);
    //         const policyLines = periods.lines;
    //         if (policyLines !== null && policyLines.length > 0) {
    //             policiesLobMap1.set([periods.policyId], periods.lines);
    //         }
    //         //
    //     });
    //     return policiesLobMap1;
    // };

    const handleError = (error) => {
    }

    const removeExpiredPolicies = (response) => {
        let data = [];
        if (response && response.length > 0) {
            data = _.filter(response, (accountPolicy) => {
                return accountPolicy.periods !== undefined && accountPolicy.periods.length > 0
            });
        }
        setAccountPolicyData(data);
         //to get document preference modal pop-up
         //uncomment during hard launch
         if(data != null){
            const value = localStorage.getItem('alreadyVisited');
            if ( _.isNull(value) || _.isUndefined(value) || value != 'true'){
                checkPaperlessCondition(data);
               localStorage.setItem('alreadyVisited', 'true');
            }
        }
    };
	
	const createPolicySummaryVM = (data) => {
        return viewModelService.create(
            data,
            'pc',
            'edge.capabilities.policy.dto.PolicyDocPreferenceDetailsDTO'
        );
    };

    useEffect(() => {
        
        setLoadingState(true);
        try {
            if (isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' })) {
                //PolicyService.getAccountPolicySummaries(authHeader).then(setAccountPolicyData, handleError),
                // PolicyService.getUserPolicySummaries(authHeader).then((responseData) => {
                //     setAccountPolicyData(removeExpiredPolicies(responseData)); 
                // }, handleError);
                PolicyService.getUserPolicySummaries(authHeader).then(removeExpiredPolicies, handleError),
                UsersProfileDetailsService.getAccountsContactSummaries(authHeader).then(setAccountData, handleError);
                getClaims(query);
            }
        } finally {
            setLoadingState(false);
        }
        // disable re render
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const aggregateBilling = useCallback((invoices) => {
        if (invoices.length === 0) {
            return null;
        }

        let total = 0;
        let due = new Date(invoices[0].dueDate);

        _.each(invoices, (invoice) => {
            total += invoice.amountDue.amount;
            const newDue = new Date(invoice.dueDate);
            if (newDue.getTime() < due.getTime()) {
                due = newDue;
            }
        });

        return {
            amountDue: {
                amount: total,
                currency: invoices[0].amountDue.currency
            },
            earliestDue: due
        };
    }, []);

    const getMyBalanceOverDueAndCurrentData = useCallback(
        (invoiceStatus) => {
            if (accountBillingData.activeInvoices) {
                const invoices = accountBillingData.activeInvoices;
                return aggregateBilling(
                    invoices.filter((invoice) => invoice.invoiceStatus === invoiceStatus)
                );
            }
            return null;
        },
        [accountBillingData.activeInvoices, aggregateBilling]
    );

    const getCellClaimStatus = (rowData, rowIndex, rowProperty) => {
        const titleMessage = translator(messages.claimStatus);
        const status = rowData[rowProperty.id];
       /*  let typeStatus = 'success';
        if (status === 'draft') {
            typeStatus = 'warning';
        } else if (status === 'closed') {
            typeStatus = 'neutral';
        }

        return (
            <InfoLabel type={typeStatus} size="small" title={titleMessage[rowProperty.id]}>
                {rowData[rowProperty.id]}
            </InfoLabel>
        ); */

        return (
            <span>
                {rowData[rowProperty.id]}
            </span>
        );
    };

    const getVisibility = () => {
        const breakpoint = useContext(BreakpointTrackerContext);
        return breakpoint === 'desktop' ? true : false;
    };

    const getBalanceData = useCallback(() => {
        const overdue = getMyBalanceOverDueAndCurrentData('due');
        const current = getMyBalanceOverDueAndCurrentData('billed');
        if (overdue && current) {
            return {
                amount: current.amountDue.amount + overdue.amountDue.amount,
                currency: current.amountDue.currency
            };
        }
        if (overdue || current) {
            return (overdue || current).amountDue;
        }
        return null;
    }, [getMyBalanceOverDueAndCurrentData]);

    const readValue = useCallback(
        (id, path) => {
            if (path === 'balanceAmount') {
                return getBalanceData();
            }
            if (path === 'overDueAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'amountDue');
            }
            if (path === 'currentAmount') {
                return _.get(getMyBalanceOverDueAndCurrentData('billed'), 'amountDue');
            }
            if (path === 'dueDate') {
                return _.get(getMyBalanceOverDueAndCurrentData('due'), 'earliestDue');
            }
            if (path === 'myCards') {
                return accountPolicyData;
            }
            return _.get(accountPolicyData, path);
        },
        [accountPolicyData, getBalanceData, getMyBalanceOverDueAndCurrentData]
    );

    const policyWithIDCard = useMemo(() => {
        let periodWithIDCard;
        accountPolicyData.some((policyData) => {
            return policyData.periods.some((period) => {
                if (period.idCardPublicID) {
                    periodWithIDCard = period;
                    return true;
                }
                return false;
            });
        });
        return periodWithIDCard;
    }, [accountPolicyData]);

    const getIDCardQuickLink = useMemo(() => {
        if (!policyWithIDCard) {
            return null;
        }
        return DocumentService.downloadPolicyDocument(
            policyWithIDCard.idCardPublicID,
            policyWithIDCard.idCardSessionID
        );
    }, [policyWithIDCard]);

    const automatedPaymentURL = useMemo(() => {
        const billingID = _.get(accountBillingData, 'manualPayPaymentGroups[0]');

        if (!billingID) {
            return undefined;
        }
        return `billing-summary/${billingID}`;
    }, [accountBillingData]);

    const firstAccountSummaryDefined = useMemo(() => {
        return accountData.length <= 1 && !_.isEmpty(accountData);
    }, [accountData]);

    const mailToTrigger = useCallback((event, email) => {
        event.preventDefault();
        window.location = `mailto:${email}`;
    }, []);

    const claimCapabilityCheck = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'fnol' });
    }, []);

    const onQuoteQuickLinkClick = useCallback(
        (lob) => () => {
            const accountSummary = accountData[0];
            const submission = {
                baseData: {
                    productCode: lob,
                    accountHolder: accountSummary,
                    accountNumber: accountSummary.accountNumber,
                    policyAddress: accountSummary.accountContact.primaryAddress,
                    periodStartDate: LocalDateUtil.today()
                }
            };
            AMPSubmissionDraftService.createForAccount(submission, authHeader).then(
                (savedSubmission) => {
                    const { url } = appConfig.quoteAndBuy;
                    const location = `${url}/quote-${getNormalizedLOBName(lob)}`;
                    const params = {
                        quoteID: savedSubmission.quoteID,
                        postalCode: savedSubmission.baseData.policyAddress.postalCode
                    };

                    window.location = generateURL(location, params);
                }
            );
        },
        [accountData, authHeader]
    );

    const getContactUsEmail = (emailId) => {
        return (
            <div> Email: &nbsp;
                <Link className={styles.link} onClick={(e) => mailToTrigger(e, emailId)} href="/">
                    {emailId}
                </Link>

            </div>
        );

    };

    const getCellAgent = useCallback(
        (rowData) => {
            return (
                <>
                    <Link className={styles.link} onClick={(e) => mailToTrigger(e, rowData.producerContact.email)} href="/">
                        {rowData.producerContact.displayName}
                    </Link>
                    <br />
                    {rowData.producerContact.phoneNumber ? (
                        <span>
                            {translator(messages.policyDetailsTel)}
                            {rowData.producerContact.phoneNumber}
                        </span>
                    ) : (
                        ''
                    )}
                </>
            );
        },
        [mailToTrigger, translator]
    );

    const renderHeaderData = useCallback(
        (rowData) => {
            const activePeriod = _.first(rowData.periods);
            // const lineOfBusiness = _.first(activePeriod.lines);
            const lineOfBusiness = activePeriod.productCode;
        //    let lOB = lineOfBusiness == 'HOPBoat_EY' ? 'InlandMarine' : lineOfBusiness;
          //  const icon = LobIconUtil.getFontIcon(lOB);
            const icon = getFontIcon(lineOfBusiness);
            let classb = lineOfBusiness == 'BusinessOwners' ? styles.eyCPPolicyTypeIcon : styles.eyPolicyTypeIcon
            
            return (
                <span>
                    <Icon icon={icon} key={lineOfBusiness} size="50px" className={classb} title={translator(messages.policyType)} />
                    <span className={styles.eyCardHeaderText}>
                    &nbsp; &nbsp; { activePeriod.productDisplayName }
                    </span>
                </span>
            );
        },
        []
    );

    const getTableOverrides = useCallback(() => {
        return {
            typeColumn: { onCell: getCellType },
            statusColumn: { onCell: getCellStatus },
            policyColumn: { onCell: getCellPolicy },
            effectiveColumn: { onCell: getCellEffective },
            premiumColumn: { onCell: getCellPremium },
            fileAClaimColumn: {
                visible: claimCapabilityCheck,
                onCell: getCellClaim
            },
            agentColumn: {
                visible: accountData.length > 1,
                onCell: getCellAgent
            }
        };
    }, [accountData, getCellAgent]);

    const generatePolicyCardOverrides = useCallback(() => {
        const overrides = accountPolicyData.map((accountPolicy, index) => {
            return {
                [`myPolicyNo${index}`]: {
                    content: getPolicyNumber(accountPolicy)
                },
                [`myPolicyStatus${index}`]: {
                    content: getCellStatus(accountPolicy)
                },
                [`myPolicyEffectiveDate${index}`]: {
                    content: getPolicyEffectiveDate(accountPolicy, index)
                },
                [`myPolicyExpiryDate${index}`]: {
                    content: getPolicyExpiryDate(accountPolicy, index)
                },
                [`viewPolicyBtn${index}`]: {
                    content: getViewPolicyBtn(accountPolicy, index)
                },
                [`policyCard${index}`]: {
                    header: renderHeaderData(accountPolicy)
                }
            };
        });

        return Object.assign({}, ...overrides);
    }, [accountPolicyData]);


    const checkPaperlessCondition = useCallback((policyData)=>{
        const { history } = props;
        if (policyData.length === 0) {
            return null;
        }
        if(policyData.length > 0){
            ModalNextProvider.showModal(
                <PaperlessDistibutionComponent
                   //data={accountPolicyData}
                    history ={history}
                     />
                ).then((response)=>{
                    console.log("Response from modal popup",response)
                    const _accountPolicyData = _.clone(policyData);
                    if(response === true){
                        _accountPolicyData.forEach((policy) => {
                            const mode = policy.dispatchMode_EY;
                            if (!Array.isArray(mode)) return;
                            const dispatchModesMap = {
                                "DigitalDelivery": "DigitalDelivery",
                                "DigitalDeliveryBroker": "DigitalDeliveryBroker",
                                "EdocDeliveryToBroker_BrokerBill": "EdocDeliveryToBroker_BrokerBill"
                            };
                            for (const key in dispatchModesMap) {
                                if (mode.includes(key)) {
                                    _.set(policy, 'policyDocDispatchMode', dispatchModesMap[key]);
                                    _.set(policy, 'policyDocDispatchModeValue', "ELECTRONIC DELIVERY");
                                    _.set(policy, 'electronicConsent_EY', "I Agree to Electronic Delivery");
                                    break;
                                }
                            }
                        });
                        setAccountData(_accountPolicyData);
                    }else if(response === false){
                        _accountPolicyData.forEach((policy) => {
                            const mode = policy.dispatchMode_EY;
                            if (!Array.isArray(mode)) return;
                            const dispatchModesMap = {
                                "MailToInsured": "MailToInsured",
                                "MailToBroker_BrokerBill": "MailToBroker_BrokerBill",
                                "MailToInsuredBroker": "MailToInsuredBroker"
                            };
                            for (const key in dispatchModesMap) {
                                if (mode.includes(key)) {
                                    _.set(policy, 'policyDocDispatchMode', dispatchModesMap[key]);
                                    _.set(policy, 'policyDocDispatchModeValue', "PAPER DELIVERY");
                                    _.set(policy, 'electronicConsent_EY', "Continue Paper Delivery");
                                    break;
                                }
                            }
                        });
                        setAccountData(_accountPolicyData);
                    }
                    
                    const accountPoliciesValue = _accountPolicyData.filter((data) => data.periods && data.periods.length > 0)
                                    .map((policySummary) => {
                                        return createPolicySummaryVM({
                                            policyNumber: policySummary.periods[0].policyId,
                                            productCode: policySummary.periods[0].productCode,
                                           // accountNumber: policySummary.accountNumber,
                                            policyDocDispatchMode: policySummary.policyDocDispatchMode,
                                            policyDocDispatchModeValue: policySummary.policyDocDispatchModeValue,
                                            dispatchMode_EYValue : policySummary.dispatchMode_EYValue,
                                            dispatchMode_EY: policySummary.dispatchMode_EY,
                                            electronicConsent_EY: policySummary.electronicConsent_EY
                                        });
                                    });
                    console.log(accountPoliciesValue);
                    const policiesValues = accountPoliciesValue.map((data) => data.value);
                    console.log(accountPoliciesValue);
                    const userName= auth.name;
                    const userEmailID = auth.user_name;
                    PolicyService.updatePolicyDocumentPreference(policiesValues,userName, userEmailID,authHeader)
                        .then((response) => {
                            if(response){
                                const location = {
                                    pathname: "/go-paperless",
                                    state: {}
                                 }
                                history.push(location);
                            }
                        }).catch((error) => {
                            console.log(error);
                        }).finally(() => {
                    });
               
                })
                .catch(_.noop);
        }
        
    },[]);

    const generateClaimDetailsOverrides = useCallback(() => {
        return {
            productColumn: { onCell: getCellProduct },
            policyNumberClaimColumn: { onCell: getCellClaimPolicyNumber },
            claimNumberColumn: { onCell: getCellClaimNumber },
            dateOfLossColumn: { onCell: getCellDateOfLoss },
            statusColumn: { onCell: getCellClaimStatus },
            claimDetailViewColumn: {
                onCell: getCellClaimDetail
            }
        };
    }, [claimDataTable]);

    const onFileAClaimQuickLinkClick = useCallback(
        () => () => {
            const { history } = props;
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [props]
    );

    const onFileAClaimButtonClick = useCallback(
        () => {
            const { history } = props;
            return history.push({
                pathname: '/fnol-select-policy',
                state: {
                    redirectPath: '/home',
                    claimData: { lossDate: new Date() }
                }
            });
        },
        [props]
    );


    const handleLinkClick = useCallback(
        (event) => {
            const { history } = props;
            return history.push(event.path);
        },
        [props]
    );

    const phoneToTrigger = useCallback((event, phone) => {
        event.preventDefault();
        window.location = `tel:${phone}`;
    }, []);

    const isAllBrokerPolicies = useCallback(() => {
        let isAllBroker = false;

        if (accountPolicyData.length > 0) {
            let brokerPolicies = accountPolicyData.filter((policySummary) => {
                return policySummary?.producerContact?.isBroker == true;
            });
            if (brokerPolicies.length === accountPolicyData.length) {
                isAllBroker = true;
            }
        }
        return isAllBroker
    }, [accountPolicyData]);

    const isBroker = useCallback(() => {
        let showBroker = false;

        if (accountPolicyData.length > 0) {
            let isBroker = accountPolicyData[0].producerContact?.isBroker;
            if(isBroker){
                showBroker = true
            }else{
                showBroker = false
            }
        }
        return showBroker;
    }, [accountPolicyData]);

    const src = getBrokerUtilLogo(accountPolicyData);
    const agentImagesrc = getAgentPhotoUtil(accountPolicyData)

    const getAdvisorName = useCallback(() => {
        let agentName = _.get(accountPolicyData[0], 'producerContact.organizationDescription')
        if (_.isEmpty(agentName)) {
            return translator(messages.na)
        }
        return agentName;
    }, [translator, accountPolicyData]);

    const getAdvisorPhone = useCallback(() => {
        let brokerphoneNumber = _.get(accountPolicyData[0], 'producerContact.brokerPhoneNumber');
        const localeService = ServiceManager.getService('locale-service');
        const phoneUtil = PhoneUtil();
        const brokerPhone =  phoneUtil.prettyPrint(brokerphoneNumber, localeService.getDefaultCountryCode());
        if (_.isEmpty(brokerPhone)) {
            return translator(messages.na)
        }
        return (
            <Link aria-label="Agent phone number" className={styles.customLink} onClick={(e) => phoneToTrigger(e, brokerPhone)} href="/">
           {brokerPhone}
            </Link>
        )
    }, [accountPolicyData]);

    const getAdvisorEmail = useCallback(() => {
        const brokerEmail = _.get(accountPolicyData[0], 'producerContact.brokerEmail');
        if (_.isEmpty(brokerEmail)) {
            return translator(messages.na);
        }
        return (
            <Link className={styles.customLink} onClick={(e) => mailToTrigger(e, brokerEmail)} href="/">
                {brokerEmail}
            </Link>
        );
    }, [accountPolicyData]);

     const getAgentTitle = useCallback(() => {
            return translator(messages.myAgent);
        }, [translator]);
    
        const getAgentName = useCallback(() => {
            let agentName = _.get(accountPolicyData[0], 'producerContact.organizationDescription')
            if (_.isEmpty(agentName)) {
                return translator(messages.na)
            }
            return agentName;
        }, [translator,accountPolicyData]);
    
       const getAgentPhone = useCallback(() => {
            let agentPhone = _.get(accountPolicyData[0], 'producerContact.phoneNumber')
           if (_.isEmpty(agentPhone)) {
               return translator(messages.na)
           }
           return (
               <Link aria-label="Agent phone number" className={styles.link} onClick={(e) => phoneToTrigger(e, agentPhone)} href="/">
                   {agentPhone}
               </Link>
           )
        }, [accountPolicyData]);
    
       const getAgentEmail = useCallback(() => {
            let agentEmail = _.get(accountPolicyData[0], 'producerContact.email')
           if (_.isEmpty(agentEmail)) {
               return translator(messages.na)
           }
           return (
          <Link className={styles.link} onClick={(e) => mailToTrigger(e, agentEmail)} href="/">
               {agentEmail}
          </Link>
           );
        }, [accountPolicyData]);

    const showBillingSection = useMemo(() => {
        return isCapabilityEnabled({ capabilitiesConfig, capabilityName: 'billing' });
    }, []);

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }
    const override = {
        '@field': {
            phone: {
                labelPosition: 'left'
            }
        },
        headerContainer: {
            visible: getVisibility()
        },
        myBalanceOverdueAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        myBalanceCurrentAmount: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        dueDateContainer: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('due'))
        },
        dueDateLabel: {
            visible: !_.isEmpty(getMyBalanceOverDueAndCurrentData('billed'))
        },
        payNowButton: {
            visible: firstAccountSummaryDefined
        },
        mediaSidebar: {
            showContact: accountData.length > 1
        },
        policiesTable: {
            data: accountPolicyData
        },
        // billingTable: {
        //     data: billingDetailsData,
        //     visible: !isAllBrokerPolicies()
        // },
        // billingEmpty: {
        //     visible: _.isEmpty(billingDetailsData),
        //     content: isAllBrokerPolicies() ? translator(messages.brokerBillingInfo) : translator(messages.billingEmpty)
        // },
        printAnIDCardLink: {
            visible: !_.isNil(policyWithIDCard),
            href: getIDCardQuickLink,
            target: '_blank'
        },
        setupAutomatedPaymentsLink: {
            to: automatedPaymentURL,
            visible: !!automatedPaymentURL && showBillingSection
        },
        getAPAQuote: {
            onClick: onQuoteQuickLinkClick('PersonalAuto'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        getAHOQuote: {
            onClick: onQuoteQuickLinkClick('Homeowners'),
            visible: appConfig.quoteAndBuy.ampQuote && firstAccountSummaryDefined
        },
        renewalNotification: {
            visible: shouldRenewalNotificationShow(accountPolicyData)
        },
        fileAClaimLink: {
            onClick: onFileAClaimQuickLinkClick(),
            visible: claimCapabilityCheck
        },
        tileGroupContainer: {
            visible: showBillingSection
        },
        makeAPaymentLink: {
            visible: showBillingSection
        },
        agentCompany: {
            content: 'ABC Insurance Brokers Ltd'
        },
        agentName: {
            content: 'MARTHA STEWART, CIP'
        },
        agentAddressLine1: {
            content: '123 Main Street, Ajax, ON, JSM 509'
        },
        // agentPhone: {
        //     content: getAgentPhone('905-352-6784')
        // },
        agentEmail: {
            content: 'Email: martha.stewart@insurance.com'
        },
        contactUsCompany: {
            content: 'Ayr Farmers Mutual'
            //content: 'EY Canada'
        },
        contactUsCompanyLine1: {
            content: 'Insurance Company'
        },
        contactUsAddressLine1: {
            content: '1400 Northumberland St'
            //content: '100 Adelaide St W, Toronto, ON M5H 0B3'
        },
        contactUsAddressLine2: {
            content: 'Ayr, ON N0B 1E0'
        },
        // contactUsPhone: {
        //     //content: 'Phone: 1-800-265-8792'
        //     content: getAgentPhone(appConfig.adjusterPhoneNumber) 
        // },
        contactUsFax: {
            //content: 'Fax: 519-632-8908'
            content: 'Fax: 516-632-8908'
        },
        contactUsEmail: {
            content: getContactUsEmail('info@ayrmutual.com')
        },
        repeatCard: {
            data: accountPolicyData
        },
        claimsTable: {
            data: claimDataTable
        },
        claimEmpty: {
            visible: _.isEmpty(claimDataTable)
        },
        fileClaimButton: {
            to: onFileAClaimButtonClick
        },
        welcomeId: {
            content: `Welcome ${useAuthentication().given_name}!`
        },
        myBillingPlan: {
            isAllBrokerPolicies: isAllBrokerPolicies(),
            showDetails: true
        },
        contactUsImage:{
            src: getImageSrc("branding/AyrLogo.png")
        },
        brokerLogoContainer:{
          visible: isBroker()
        },
        advisorName: {
            content: getAdvisorName()
        },
        advisorPhone: {
            content: getAdvisorPhone()
        },
        advisorEmail: {
            content: getAdvisorEmail()
        },
        brokerLogoImage:{
            visible: !!src,
             src: src
        },
        myAgentTableContainer:{
            visible: !isBroker()
        },
        agentName: {
            content: getAgentName()
         },
        agentPhone: {
            content: getAgentPhone()
         },
        agentEmail: {
            content: getAgentEmail()
        }, 
        myAgentTableTitle: {
            content: getAgentTitle()
        },
        agentIconImage:{
            visible: !!agentImagesrc,
             src: agentImagesrc
        },
        ...getTableOverrides(),
        ...generatePolicyCardOverrides(),
        //...generateBillingDetailsOverrides(),
        ...generateClaimDetailsOverrides()
    };
    

    const resolvers = {
        resolveClassNameMap: styles,
        resolveValue: readValue,
        resolveCallbackMap: {
            handleLinkClick,
            onFileAClaimButtonClick
        },
        resolveComponentMap: {
            pagebannercomponent: PageBannerComponent,
            BillingTable: BillingTable
        }
    };

    return renderContentFromMetadata(metadata.pageContent, override, resolvers);
}

export default withRouter(LandingPage);
